import { useContext } from 'react';
import PageContext from './PageContext';
import greenCircleIcon from '../../svgs/green-circle-icon.svg';
import redCircleIcon from '../../svgs/red-circle-icon.svg';
import RowEditIcon from './RowEditIcon';
import PageTooltip from './PageTooltip';
import downloadIcon from '../../svgs/download-icon.svg';  
import ExportS3Icon from './ExportS3Icon'; 
import { HttpContext } from '../../api-services/HttpService';
import displayDateTime from '../functions/displayDateTime'; 
import { TableCell } from '@mui/material';
import ChatIcon from '../../svgs/chat-icon.svg';

// pass row object as prop
const SubCompanyRow = ({ row, count, tableHeader, enableEdit,stickyEnabled }) =>{
    // get context variables from parent 
    const {
        showContractCommentModal, 
        setShowContractCommentModal, 
        showEditContractModal, 
        setShowEditContractModal, 
        contractUploadRow, 
        setContractUploadRow,
    } = useContext(PageContext);  
    // get request functions from HttpContext
    const {
        GET,
    } = useContext(HttpContext); 

    // event handler for edit icon click 
    const onEditClick = () => {
        // pass row to modal 
        setContractUploadRow(contractUploadRow => contractUploadRow = row); 
        // show modal 
        setShowEditContractModal(showEditContractModal => showEditContractModal = true); 
    }

    // event handler for view comment click 
    const onViewClick = () => {
        // pass row to modal 
        setContractUploadRow(contractUploadRow => contractUploadRow = row); 
        // show modal 
        setShowContractCommentModal(showContractCommentModal => showContractCommentModal = true); 
    }

    const getRowClassName = (columnOrder) =>{
        // Pass sticky row class if columnOrder is 0 i.e first column and stickyEnabled Prop is true
        return stickyEnabled && columnOrder===0 ? "table-cell-sticky-row": ""
    }

    // event handler for downloading pdf
    const onDownloadClick = () => {
        // get presignedURL (this function is passed to ExportS3Icon)
        return new Promise((resolve, reject) => {
            GET('/presigned/contract', {
                fileName:  row['uploadfilename'], 
            }).then(res => {
                resolve({ data: {
                    'PresignedUrlDownload': res['data']['downloadURL'] // key for compatibility with ExportS3Icon
                }}); 
            }).catch(err => {
                reject(err);
            });
        }); 
    }

    // display red circle for disabled (0) status or green circle for active (1) status
    const statusIcon = (status) =>{
        if ( status == true){
            return <img src={greenCircleIcon} class='data-table-icon-left'/>
        }
        else {
            return <img src={redCircleIcon} class='data-table-icon-left'/>
        }
    }

    return(
        <>
            {/* map logic over ever column in row object */}
            {tableHeader.map(el =>
                // if status column apply statusIcon function 
                el['columnname'] == 'active' ?
                    <TableCell className={getRowClassName(el['columnorder'])}>{statusIcon(row[el['columnname']])}</TableCell>
                : el['columnname'] == 'blank' ?
                    <TableCell className={getRowClassName(el['columnorder'])}>
                        {/* show icon to download pdf */}
                        <PageTooltip title='download'>
                            <ExportS3Icon tag={row['displayfilename']} getData={onDownloadClick} removeDate={true} deleteFile={false} icon={downloadIcon} css='data-table-icon' fileType={'application/pdf'} fileExtension={'.pdf'}/>
                        </PageTooltip>
                        {/* show icon to view comment */}
                        <PageTooltip title='view'>
                            <img src={ChatIcon} className='data-table-icon' onClick={onViewClick}/> 
                        </PageTooltip>
                        {/* show edit icon to trigger EditSubCompanyRow modal */}
                        <RowEditIcon enable={enableEdit} onClick={onEditClick}/>
                    </TableCell>
                : el['columnname'] == 'uploadedtimestamp' ? 
                    <TableCell className={getRowClassName(el['columnorder'])}>{displayDateTime(row[el['columnname']])}</TableCell>
                : row[el['columnname']] == null ?
                    <TableCell className={getRowClassName(el['columnorder'])}>None</TableCell>
                // standard display for all other columns 
                :<TableCell className={getRowClassName(el['columnorder'])}>{row[el['columnname']]}</TableCell>
            )}
            
        </>
    );
}

export default SubCompanyRow; 